const widthS = 170;
const widthM = 220;
const widthL = 200;
const widthA = '*';     // css table column width '*' => evenly distribute remaining width after rendering fixed-width columns

export const gridColumns =
    [
        {
            field: 'startTimeLabel', caption: 'Start Time', width: widthS, type: 'number',
        },

        {
            field: 'endTimeLabel', caption: 'End Time', width: widthS, type: 'number'
        },
        {
            field: 'length', caption: 'Length', width: widthS, type: 'string' 
        },
        {
            field: 'campaignId', caption: 'Campaign ID', width: widthL, type: 'string'
        },
        {
            field: 'campaignName', caption: 'Campaign Name', width: widthA, type: 'string'
        },
        {
            field: 'spotTypeName', caption: 'Spot Type', width: widthM, type: 'string',
        }
    ];
